import XDate from 'xdate';
import { I18n } from '~/common/explicit-exports';

type ExpiryDateFormat = 'default_with_slashes' | 'medium' | 'locale';

type ExpiryData = {
  expiresDate: XDate;
  hasExpired: boolean;
  translatedExpiresDate: string;
  translatedExpiresText: string;
  translatedExpiresTextWithDate: string;
};

type GetExpiryDataOptions = {
  dateFormat: ExpiryDateFormat;
  useShortLabel: boolean;
};

export function getExpiryData(
  awardedAt: number,
  expiresAt: number,
  getOptions: Partial<GetExpiryDataOptions> = {},
): Partial<ExpiryData> {
  if (expiresAt) {
    const options = { dateFormat: 'default_with_slashes', ...getOptions };

    // [PAR-1155] match hh:mm:ss from awardedAt for consistent display
    const expiresDate = new XDate(awardedAt ? expiresAt + (awardedAt % 86_400_000) : expiresAt, true);
    const now = new XDate();
    const hasExpired = now > expiresDate;

    const translatedExpiresDate =
      options.dateFormat === 'locale'
        ? expiresDate.toLocaleDateString()
        : I18n.l(`date.formats.${options.dateFormat}`, expiresDate as unknown as Date);

    const translationKey = hasExpired ? 'expired' : 'expires';
    const translatedExpiresText = I18n.t(
      options.useShortLabel
        ? `js.learner.certifications.${translationKey}`
        : `js.academy.certifications.${translationKey}_on_label`,
    );
    const translatedExpiresTextWithDate = I18n.t(`js.academy.certifications.${translationKey}_on`, {
      date: translatedExpiresDate,
    });

    return {
      expiresDate,
      hasExpired,
      translatedExpiresDate,
      translatedExpiresText,
      translatedExpiresTextWithDate,
    };
  }

  return {};
}
